module.exports = __webpack_public_path__ + "static/media/eocene_image_infrared_ear_and_body_termotransparent.30513171.png";